/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminMemberRole
 */
export interface AdminMemberRole {
    /**
     * 
     * @type {number}
     * @memberof AdminMemberRole
     */
    admin?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMemberRole
     */
    adminMemberRoleId?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminMemberRole
     */
    adminMemberRoleName?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminMemberRole
     */
    articleManagement?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMemberRole
     */
    discountManagement?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMemberRole
     */
    inventoryManagement?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMemberRole
     */
    marketingEventManagement?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMemberRole
     */
    membershipManagement?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMemberRole
     */
    membershipManagementRead?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMemberRole
     */
    orderManagement?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMemberRole
     */
    orderManagementRead?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMemberRole
     */
    pointManagement?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMemberRole
     */
    productManagement?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMemberRole
     */
    productPriceManagement?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMemberRole
     */
    stockLevelManagement?: number;
}

export function AdminMemberRoleFromJSON(json: any): AdminMemberRole {
    return AdminMemberRoleFromJSONTyped(json, false);
}

export function AdminMemberRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminMemberRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'admin': !exists(json, 'admin') ? undefined : json['admin'],
        'adminMemberRoleId': !exists(json, 'adminMemberRoleId') ? undefined : json['adminMemberRoleId'],
        'adminMemberRoleName': !exists(json, 'adminMemberRoleName') ? undefined : json['adminMemberRoleName'],
        'articleManagement': !exists(json, 'articleManagement') ? undefined : json['articleManagement'],
        'discountManagement': !exists(json, 'discountManagement') ? undefined : json['discountManagement'],
        'inventoryManagement': !exists(json, 'inventoryManagement') ? undefined : json['inventoryManagement'],
        'marketingEventManagement': !exists(json, 'marketingEventManagement') ? undefined : json['marketingEventManagement'],
        'membershipManagement': !exists(json, 'membershipManagement') ? undefined : json['membershipManagement'],
        'membershipManagementRead': !exists(json, 'membershipManagementRead') ? undefined : json['membershipManagementRead'],
        'orderManagement': !exists(json, 'orderManagement') ? undefined : json['orderManagement'],
        'orderManagementRead': !exists(json, 'orderManagementRead') ? undefined : json['orderManagementRead'],
        'pointManagement': !exists(json, 'pointManagement') ? undefined : json['pointManagement'],
        'productManagement': !exists(json, 'productManagement') ? undefined : json['productManagement'],
        'productPriceManagement': !exists(json, 'productPriceManagement') ? undefined : json['productPriceManagement'],
        'stockLevelManagement': !exists(json, 'stockLevelManagement') ? undefined : json['stockLevelManagement'],
    };
}

export function AdminMemberRoleToJSON(value?: AdminMemberRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'admin': value.admin,
        'adminMemberRoleId': value.adminMemberRoleId,
        'adminMemberRoleName': value.adminMemberRoleName,
        'articleManagement': value.articleManagement,
        'discountManagement': value.discountManagement,
        'inventoryManagement': value.inventoryManagement,
        'marketingEventManagement': value.marketingEventManagement,
        'membershipManagement': value.membershipManagement,
        'membershipManagementRead': value.membershipManagementRead,
        'orderManagement': value.orderManagement,
        'orderManagementRead': value.orderManagementRead,
        'pointManagement': value.pointManagement,
        'productManagement': value.productManagement,
        'productPriceManagement': value.productPriceManagement,
        'stockLevelManagement': value.stockLevelManagement,
    };
}

